import {
  getListSubscription,getListVerifyStudent,getListVerifyStudentHistory,
  getSubscriptionHistory,getSubscriptionReceipt,
} from '@/services/subscription';

const getters = {
  list_subscription: state => state.list_subscription,
  list_verify_student: state => state.list_verify_student,
  list_verify_student_history: state => state.list_verify_student_history,
  per_page: state => state.per_page,
};

const actions = {
  async requestListSubscription({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListSubscription({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] },filter);
      commit('SET_LIST_SUBSCRIPTION', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
async requestAddSubscriptionPrice({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
        await addSubscriptionPrice({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] },data);
        dispatch('requestListSubscription', filter);
    } catch (err) {
        commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
        throw err;
    } finally {
        commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
},
  async requestListVerifyStudent({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListVerifyStudent({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] },filter);
      commit('SET_LIST_VERIFY_STUDENT', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListVerifyStudentHistory({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListVerifyStudentHistory({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] },filter);
      commit('SET_LIST_VERIFY_STUDENT_HISTORY', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListSubscriptionHistory({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = { data: [], total: 0 };
    try {
      const response = await getSubscriptionHistory(
        {
          tokenType: rootGetters['AuthModule/tokenType'],
          accessToken: rootGetters['AuthModule/accessToken'],
        },
        filter,
      );
      returnRes =
        response.data !== undefined
          ? { data: response.data.data, total: response.data.total }
          : returnRes;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestSubscriptionReceipt({ commit, rootGetters }, id) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const response = await getSubscriptionReceipt(
        {
          tokenType: rootGetters['AuthModule/tokenType'],
          accessToken: rootGetters['AuthModule/accessToken'],
        },
        id,
      );
      returnRes = response;
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'SubscriptionReceiptError' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
};

const mutations = {
  SET_LIST_SUBSCRIPTION(state, list_subscription) {
    state.list_subscription = list_subscription;
  },
  SET_LIST_VERIFY_STUDENT(state, list_verify_student) {
    state.list_verify_student = list_verify_student;
  },
  SET_LIST_VERIFY_STUDENT_HISTORY(state, list_verify_student_history) {
    state.list_verify_student_history = list_verify_student_history;
  },
};

export default {
  namespaced: true,
  state: {
    list_subscription: [],
    list_verify_student: [],
    list_verify_student_history: [],
    per_page: 50,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Subscription/index.js